import { render, staticRenderFns } from "./TicketTabList.vue?vue&type=template&id=000ad624"
import script from "./TicketTabList.vue?vue&type=script&lang=js"
export * from "./TicketTabList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports